<template>
  <div class="container">
    <content-header :data="[{text:'投票奖品一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="请输入查询关键字"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="name"
            label="名称"
            width="200">
          </el-table-column>
          <el-table-column
            label="图片">
            <template slot-scope="scope">
            <img style="width:102px;height:36px":src="scope.row.imageUrl" v-if="scope.row.imageUrl"/>
            </template>
          </el-table-column>
          <!--el-table-column
            prop="modifier_name"
            label="操作人"
            width="100">
          </el-table-column>
          <el-table-column
            prop="modified"
            label="操作时间"
            width="180">
          </el-table-column-->
          <el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > curSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="curSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建品牌弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改奖品' : '添加奖品'" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
            <el-form-item prop="name" label="名称" :label-width="formLabelWidth">
              <el-input name="name" v-model="curObj.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="imageUrl" label="图片" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader"
                action="//upload-z2.qiniup.com"
                :data="uploadForm"
                :show-file-list="false"
                :on-success="uploadPhotoSuccess"
                :before-upload="beforePhotoUpload"
                :on-error="uploadError">
                <img v-if="curObj.imageUrl" :src="curObj.imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import date from 'utils/date'
  import VoteModel from 'models/vote'
  import CommonModel from 'models/common'

  export default {
    data () {
      return {
        keywords: '',
        tableData: [],
        isObjShow: false,
        curObj: {
          id: '',
          name: '',
          imageUrl: ''
        },
        formLabelWidth: '80px',
        curObjRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          imageUrl: [{ required: true, message: '请上传图片', trigger: 'blur' }]
        },
        curPage: 1,
        curSize: 10,
        total: 0,

        //
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
      }
    },
    created () {
      this.getObjList()
    },
    methods: {
      //
      uploadRemove (file, fileList) {
        console.log(file)
      },
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadExceed (files, fileList) {
        console.log(files.length)
      },
      uploadPhotoSuccess (response, file, fileList) {
        // console.log(response)
        this.curObj.imageUrl = this.qiniuHost + response.key
        // console.log(this.curObj.imageUrl)
      },
      beforePhotoUpload (file) {
        // console.log(file)
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          return false
        }
        //
        let curr = date(new Date().getTime(), 'yyyyMMdd')
        let prefix = 'vote'
        let ext = file.name.split('.').pop()
        let suffix = this.$md5(file.name)
        if (!this.uploadForm.token) {
          return CommonModel.getQiniuUptoken().then(res => {
            this.qiniuHost = res.qiniuHost
            this.uploadForm.token = res.uptoken
            this.uploadForm.key = encodeURI(`${prefix}/${curr}_${suffix}.${ext}`)
            // console.log(this.uploadForm)
          })
        } else {
          this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}.${ext}`)
          // console.log(this.uploadForm)
        }
        return true
      },
      //
      pageSizeChange (size) {
        this.curSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.curSize,
          keywords: this.keywords
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        VoteModel.findPrize(_opts).then(res => {
          this.tableData = res.rows
          this.total = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            VoteModel.deletePrize({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          name: '',
          imageUrl: ''
        }
        this.isObjShow = true
      },
      newHandle () {
        VoteModel.createPrize({
          name: this.curObj.name,
          imageUrl: this.curObj.imageUrl
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = {
          id: item.row.id,
          name: item.row.name,
          imageUrl: item.row.imageUrl
        }
        this.isObjShow = true
      },
      editHandle () {
        VoteModel.updatePrize({
          id: this.curObj.id,
          name: this.curObj.name,
          imageUrl: this.curObj.imageUrl
        }).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      searchHandle () {
        this.getObjList()
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 20px
        span
          display: inline-block
          vertical-align: top
          line-height: 36px
        .entry-box
          display: inline-block
          vertical-align: top
          width: 140px
          &.username
            width: 140px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
      .avatar-uploader
          border: 1px dashed #d9d9d9
          border-radius: 6px
          cursor: pointer
          position: relative
          overflow: hidden
          width: 206px
          &:hover
            border-color: #409EFF
          .avatar-uploader-icon
            font-size: 28px
            color: #8c939d
            width: 204px
            height: 172px
            line-height: 172px
            text-align: center
          .avatar
            width: 204px
            height: 172px
            display: block
</style>



// WEBPACK FOOTER //
// src/views/VotePrize.vue